/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @author Jiri Moc <jiri.moc@outlook.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { Form } from "../shared/FormModel/FormModel";
import { SectionGroup } from "../shared/FormModel/elements/FormSectionGroup";
import { Section } from "../shared/FormModel/elements/FormSection";
import { Row } from "../shared/FormModel/elements/FormRow";
import { HTMLContent } from "../shared/FormModel/elements/FormHTMLContent";
import { FieldText } from "../shared/FormModel/elements/FormFieldText";
import { FieldLabel } from "../shared/FormModel/elements/FormFieldLabel";

export const form_gdpr = Form({
	id: "gdpr",
	version: "2020-07-r1",
	title: "GDPR",
	icon: "shield-account",
	showInMenu: true
}, [
	SectionGroup({}, [
		Section({
			id: "gdpr",
			title: "Informace o zpracování osobních údajů"
		}, [
			Row({}, [
				HTMLContent({}, (data) => <>
					<h3 style={{
						fontWeight: "bold"
					}}>
						Správce osobních údajů
					</h3>
					<p style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						Tomáš Zimmel<br />
						Ledenická - Škarda 1252, Srubec, 370 06<br />
						IČO: 741 71 364<br />
						DIČ: CZ8503201377<br />
						tel: +420 792 313 446<br />
						e-mail: zimmel@kuchynerondo.cz, ztkuchyne@seznam.cz<br />
						dále jen jako
						"<strong style={{
							fontWeight: "bold"
						}}>
							Správce
						</strong>"
				</p>
				</>)
			]),
			Row({}, [
				HTMLContent({}, (data) => <>
					<h3 style={{
						fontWeight: "bold"
					}}>
						Jaké údaje zpracováváme
					</h3>
					<p style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						Ve smyslu zákona č.101/2000 Sb., o ochraně osobních údajů a zárověň v souladu s Nařízením (EU) 2016/679 zpracováváme tyto osobní údaje:
					</p>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							jméno a příjmení
						</li>
						<li>
							adresu a adresu montáže či dodávky, popř. informace o parcele
						</li>
						<li>
							e-mailovou adresu, telefon
						</li>
						<li>
							veškeré požadavky a informace zapsané v tomto registračním formuláři, případně další, které nám v budoucnu během našeho společného jednání poskytnete
						</li>
						<li>
							Vámi poskytnuté kopie projektových dokumentací, výkresů, návrhů, apod.
						</li>
					</ol>
				</>)
			]),
			Row({}, [
				HTMLContent({}, (data) => <>
					<h3 style={{
						fontWeight: "bold"
					}}>
						Účel a délka zpracování údajů
					</h3>
					<p style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						Zpracování Vašich osobních údajů provádíme za účelem vytvoření návrhu či nabídky zboží, kalkulace, popř. objednávky zboží. Vaše osobní údaje uchováváme od chvíle, kdy nám je sdělíte a dáte k jejich zpracování souhlas po dobu, která je nezbytná vzhledem k účelu jejich zpracování. Dále je využíváme pro:
					</p>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							plnění povinností vyplývajících ze smluv
						</li>
						<li>
							plnění povinností vyplývajících z podmínek využívaných služeb
						</li>
						<li>
							plnění povinností vyplývajících z obecně závazných právních předpisů
						</li>
						<li>
							zajištění ochrany našich práv a oprávněných zájmů
						</li>
					</ol>
				</>)
			]),
			Row({}, [
				HTMLContent({}, (data) => <>
					<h3 style={{
						fontWeight: "bold"
					}}>
						Sdílení osobních údajů s třetími stranami
					</h3>
					<p style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						Zpracování osobních údajů provádí Správce, ale úzce spolupracujeme s různými poskytovateli služeb, kterým některé Vaše údaje předáváme. Vzhledem k tomu, že jsme tyto poskytovatele služeb zavázali, aby zpracování údajů prováděli jako pověření zpracovatelé údajů v souladu s přísnými pokyny, nevyžadují žádné činnosti v rámci zpracování údajů prováděné těmito zpracovateli Váš souhlas. Seznam těchto třetích stran se může měnit v čase.
					</p>
					<p style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						Ke zpracování vašich osobních údajů využíváme služeb dalších zpracovatelů. Pro e-mailovou komunikaci využíváme služby splečnosti ACTIVE 24, s.r.o. (IČ: 25115804). Pro zpracování zakázek využíváme služeb služby <a href="https://trello.com/">Trello</a>, jejíž zásady zpracování jsou dostupné <a href="https://help.trello.com/article/1118-trello-and-gdpr-our-commitment-to-data-privacy">na této adrese</a>.
					</p>
				</>)
			]),
			Row({}, [
				HTMLContent({}, (data) => <>
					<h3 style={{
						fontWeight: "bold"
					}}>
						Poučení o Vašich právech
					</h3>
					<p style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						Máte právo si od nás vyžádat údaje, které o Vás zpracováváme, máte právo na opravu či doplnění Vašich osobních údajů. Požádáte-li nás, máte právo na vymazání Vašich osobních údajů. Některé údaje, ale budou vymazány až po uplynutí stanovené lhůty, po kterou jsme zavázáni je uchovat, například z důvodu, že jsme povinni v některých případech uchovávat tyto údaje ze zákona. Dalším důvodem může být potřeba těchto údajů ke splnění smluvních závazků vůči Vám. Máte právo na zablokování Vašich údajů a kdykoliv máte právo odvolat Váš souhlas se zpracováním Vašich osobních údajů. Dále máte právo vznést námitky proti zpracování Vašich údajů.
					</p>
					<p style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						V případě podezření na neoprávněné využití Vámi poskytnutých údajů, máte právo předat podnět k šetření Úřadu pro ochranu osobních údajů.
					</p>
				</>)
			]),
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "podpisova_sekce",
			title: "Potvrzení převzetí formuláře"
		}, [
			Row({
				id: "podpisy"
			}, [
				HTMLContent({}, (data) => <>
					<p style={{
						fontWeight: "bold",
						textAlign: "center"
					}}>
						Svobodně a dobrovolně beru na vědomí zpracování osobních údajů, specifikovaných výše
					</p>
					<table style={{
						width: "100%"
					}}>
						<tr>
							<td style={{
								width: "50%",
								textAlign: "center",
								verticalAlign: "middle",
								padding: "15px",
								paddingTop: "50px"
							}}
								colSpan={2}
							>
								V Českých Budějovicích, dne:
							</td>
						</tr>
						<tr>
							<td style={{
								width: "50%",
								textAlign: "center",
								verticalAlign: "middle",
								padding: "15px",
								paddingTop: "100px"
							}}>
								<p>
									. . . . . . . . . . . . . . . . . . . .
								</p>
								<p>
									<strong>Podpis a razítko<br />prodejce</strong>
								</p>
							</td>
							<td style={{
								width: "50%",
								textAlign: "center",
								verticalAlign: "middle",
								padding: "15px",
								paddingTop: "100px"
							}}>
								<p>
									. . . . . . . . . . . . . . . . . . . .
								</p>
								<p>
									<strong>Podpis<br />zákazníka</strong>
								</p>
							</td>
						</tr>
					</table>
				</>)
			]),
		])
	])
]);